export default __webpack_public_path__ + "static/FoundersGrotesk-Semibold-13e6dc2b9e3d192eabcfdc1367dc9948.ttf";